import { render, staticRenderFns } from "./ViewPlanPermissions.vue?vue&type=template&id=bcf9f0ac"
import script from "./ViewPlanPermissions.vue?vue&type=script&lang=js"
export * from "./ViewPlanPermissions.vue?vue&type=script&lang=js"
import style0 from "./ViewPlanPermissions.vue?vue&type=style&index=0&id=bcf9f0ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports